export default function getVideoEmbed(raw) {
  if (!raw) return null;
  const url = String(raw).trim();

  if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(url)) {
    return { type: "file", src: url };
  }
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([A-Za-z0-9_-]{6,})/);
  if (yt) {
    const id = yt[1];
    return {
      type: "youtube",
      src: `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&showinfo=0&loop=1&playlist=${id}`,
    };
  }
  return null;
}
